var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#3A3C3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "#3A3C3F",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plusIconTitle"
  }, "Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plusIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12L4 12M12 4L12 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusB);
export default __webpack_public_path__ + "static/media/plusB.9193b976332dc3c35505ba63356e0d7c.svg";
export { ForwardRef as ReactComponent };